export default "__VITE_ASSET__Dtc0G1mK__"